import { modalService } from "framework";
import store from "../../store.js"

class ChangeTracker {
    constructor() {
      this.changeMade = (data) => {
          store.commit("changeTracker/changeMade", data);
        };
        this.clear = () => { 
            store.commit("changeTracker/clear");
        }
    }

    getHierarchy(component) {
        if (component.$parent) {
            return this.getHierarchy(component.$parent) + "/" + (component.$options._componentTag || "None");
        }
        else
        {
            return component.$options._componentTag;
        }
    }

    async confirmNavigation() {
        var s = store.state.changeTracker;
        if (!s.changesPending) return;
        if (s.changeData && s.changeData.component) {
            console.log(`Discard Changes for: '${s.changeData.name}' ${this.getHierarchy(s.changeData.component)}`);
        }
        await modalService.discard("Changes will be discarded. Are you sure?");
        this.clear();
    }
}

const changeTracker = new ChangeTracker();

export default changeTracker;



// WEBPACK FOOTER //
// ./src/framework/utils/change-tracker.js